import { render, staticRenderFns } from "./ProfileCheckbox.vue?vue&type=template&id=061ac04c&"
import script from "./ProfileCheckbox.vue?vue&type=script&lang=js&"
export * from "./ProfileCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports